module.exports = __webpack_public_path__ + "components/weather-icon/static/daycloud@2-6715965417e15aa3ce28fc7ede4e5ff9.png";